module.exports = __webpack_public_path__ + "static/media/AvantBook.01f3e43d.otf";